import { useNavigate } from "react-router-dom";
import Image from './images/trackr-logo-label.png'
const Logo = () => {
    const navigate = useNavigate();

    return (
        <img 
            onClick={() => navigate('/')}
            alt='Trackr Logo'
            className="block cursor-pointer"
            height='28'
            width='107'
            src={Image}
        />
    )

};

export default Logo;